// @ts-nocheck

import type { DiscountApplication } from './discount-application.model';
import type { LineItem } from './line-item.model';

export class Cart {
  token: string;
  note: string;
  attributes: Map<string, string>;
  total_price: number;
  total_discount: number;
  total_weight: number;
  item_count: number;
  items: LineItem[] = [];
  requires_shipping: boolean;
  currency: string;
  items_subtotal_price: number;
  original_total_price: number;
  cart_level_discount_applications: DiscountApplication[] = [];
}
